<template>
  <div class="af-share">
    <div>Tipsa en vän om Jobskills</div>
    <div class="af-share__options">
      <a v-for="option in shareOptions" :href="option.link" :key="option.iconType" class="af-share__link">
        <icon fill="#fff" :type="option.iconType" />
      </a>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon"

export default {
  name: 'af-share',
  components: {
    Icon
  },

  data() {
    return {
      jobskillsURL: window.__JOBSKILLS_URL__,
      baseURL: window.__BASE_URL__,
      shareOptions: [
        {
          link: `mailto:?body=${window.__BASE_URL__}`,
          iconType: 'envelope'
        },
        {
          link: `http://www.facebook.com/sharer.php?u=${window.__BASE_URL__}`,
          iconType: 'facebook-f'
        },
        {
          link: `https://twitter.com/intent/tweet?text=${window.__BASE_URL__}`,
          iconType: 'twitter'
        },
        {
          link: `https://www.linkedin.com/shareArticle?mini=true&url=${window.__BASE_URL__}`,
          iconType: 'linkedin'
        }
      ]
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../variables/custom-media.css';

.af-share {
  align-items: center;
  display: flex;
  margin-top: var(--spacing-medium);

  @media (--bp-nis-extra-small) {
    justify-content: center;
  }

  @media (--bp-iphone5) {
    flex-direction: column;
  }
}

.af-share__options {
  margin-left: var(--spacing-third);
}

.af-share__link {
  margin-left: var(--spacing-third);
}
</style>



// WEBPACK FOOTER //
// src/components/Share.vue